import React from "react";
import { makeStyles } from "@material-ui/core/styles";

import { Box } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";

const useStyles = makeStyles(theme => ({
  labelAndValue: {
    "& label": {
      fontWeight: "bold",
      paddingRight: theme.spacing(2),
    },
  },
}));

const RefererAuthenticationCell = props => {
  const { authentication } = props;
  const classes = useStyles();

  return (
    <Grid container spacing={1}>
      <Grid item sm={12}>
        <Box className={classes.labelAndValue}>
          <label>Referer URL:</label>
          {authentication.refererUrl}
        </Box>
      </Grid>
    </Grid>
  );
};

export default RefererAuthenticationCell;
